import { Flex, Text } from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../../../../../utils";
import NumberField from "../../../../../../../../../components/NumberField/NumberField";
import * as React from "react";
import { useMemo } from "react";
import { DataTable } from "../../../../../../../../../components/DataTable";
import { useTranslation } from "react-i18next";

function PurchasedGoodsAndServicesTab({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.purchasedGoodsAndServices.purchased"
  });

  const columns = useMemo(() => [
      {
        header: t("gridColumns.emissionsType"),
        accessorKey: "emissionsType",
        size: 500
      },
      {
        header: translateSubElementString("reportsPage.scopeThree.inputs.purchasedGoodsAndServices.purchased.gridColumns.totalEmissions"),
        accessorKey: "totalEmissions",
        size: 250
      }
    ],
    [t]
  );

  const mapData = (data) => {
    return data && data.purchasedGoodsAndServices ? [
      {
        emissionsType: t("scopeOneEmission"),
        totalEmissions: data.purchasedGoodsAndServices.scopeOneEmission ?? ""
      },
      {
        emissionsType: t("scopeTwoEmission"),
        totalEmissions: data.purchasedGoodsAndServices.scopeTwoEmission ?? ""
      },
      {
        emissionsType: t("scopeThreeEmission"),
        totalEmissions: data.purchasedGoodsAndServices.scopeThreeEmission ?? ""
      }
    ] : [];
  };

  return (
    <>
      <DataTable
        data={mapData(data)}
        columns={columns}
        containerHeight="300px"
        marginBlockEnd={4}
      />
      <Flex>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.purchasedGoodsAndServices.purchased.totalEmissions"
          )}
        </Text>
        <NumberField value={data?.purchasedGoodsAndServices?.totalCo2Emissions ?? ""} marginStart="2" />
      </Flex>
    </>
  );
}

export default PurchasedGoodsAndServicesTab;